/**
 * Created by Bazu-05 on 27.01.2020.
 */


export const alert = {
    state: {
        alerts: [],
    },
    getters: {
        alerts: state => state.alerts
    },
    mutations: {
        ADD_ALERT(state, payload) {
            state.alerts.push(payload)
        },
        REMOVE_ALERT(state, payload) {
          const alert = state.alerts.findIndex(alert => alert.id === payload)
          state.alerts.splice(alert, 1)
        },

    },
    actions: {
        ADD_ALERT({commit, state, dispatch}, {type, text}){
            const createId = () => Date.now().toString(36) + Math.random().toString(36).substr(2);
            const id = createId();

            setTimeout(() => {
                const alert = state.alerts.findIndex(alert => alert.id == id)
                if(alert !== -1) {
                    dispatch('REMOVE_ALERT', id);
                }
            }, 5300);

            commit('ADD_ALERT', {
                id: id,
                type: type,
                text: text,
            })


        },
        REMOVE_ALERT({commit}, id) {
            commit('REMOVE_ALERT', id)
        },
    }
}